import { render, staticRenderFns } from "./labelAdd.vue?vue&type=template&id=4c5271d3&scoped=true"
import script from "./labelAdd.vue?vue&type=script&lang=js"
export * from "./labelAdd.vue?vue&type=script&lang=js"
import style0 from "./labelAdd.vue?vue&type=style&index=0&id=4c5271d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5271d3",
  null
  
)

export default component.exports